
import React from "react";
export default function AlertIcon(props) {

	const fill = props.fill  || "#CC6058";
	const width = props.width  || "100";

	return (<svg width={width} viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="55.5" cy="55.5" r="55.5" fill={fill} fill-opacity="0.15"/>
		<path d="M49 67.38C49 70.042 51.158 72.2 53.82 72.2V72.2C56.482 72.2 58.64 70.042 58.64 67.38V33.82C58.64 31.158 56.482 29 53.82 29V29C51.158 29 49 31.158 49 33.82V67.38ZM49 82.18C49 84.6211 50.9789 86.6 53.42 86.6H54.22C56.6611 86.6 58.64 84.6211 58.64 82.18V82.18C58.64 79.7389 56.6611 77.76 54.22 77.76H53.42C50.9789 77.76 49 79.7389 49 82.18V82.18Z"
			  fill={fill}/>
	</svg>)
}


